"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9306,3753],{

/***/ 54798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCarouselNext = function SvgCarouselNext(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 29,
        fill: "none",
        viewBox: "0 0 18 29"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#323338",
        fillRule: "evenodd",
        d: "m16.467 12.909-1.65 1.591 1.65 1.591c.91-.879.91-2.303 0-3.182M11.52 14.5.733 24.909a2.195 2.195 0 0 0 0 3.182c.91.879 2.387.879 3.297 0l12.437-12-1.65-1.591 1.65-1.591L4.03.909a2.39 2.39 0 0 0-3.297 0 2.195 2.195 0 0 0 0 3.182z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCarouselNext);


/***/ }),

/***/ 69395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCarouselPrev = function SvgCarouselPrev(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 29,
        fill: "none",
        viewBox: "0 0 18 29"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#323338",
        fillRule: "evenodd",
        d: "m.683 15.841 1.649-1.591-1.649-1.591a2.195 2.195 0 0 0 0 3.182M5.63 14.25 16.417 3.841c.91-.879.91-2.303 0-3.182a2.39 2.39 0 0 0-3.298 0l-12.436 12 1.649 1.591-1.649 1.591 12.436 12c.911.879 2.387.879 3.298 0 .91-.879.91-2.303 0-3.182z",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCarouselPrev);


/***/ }),

/***/ 95890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ images_grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
;// CONCATENATED MODULE: ./segments/desktop/grid/grid-service.js
var MOBILE_GRID_IMAGE_SIZE = 300;
var getImageSize = function(numberOfImages) {
    var isMobileOrTablet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isMobileOrTablet) return {
        width: MOBILE_GRID_IMAGE_SIZE,
        height: "auto"
    };
    switch(numberOfImages){
        case 1:
            return {
                width: 607,
                height: 346
            };
        case 2:
            return {
                width: 607,
                height: 346
            };
        case 3:
            return {
                width: 400,
                height: 346
            };
        case 4:
            return {
                width: 300,
                height: 300
            };
        default:
            return {
                width: 300,
                height: 300
            };
    }
};

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./utils/arrays.js
var arrays = __webpack_require__(84657);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/default-props.js

/* harmony default export */ var default_props = ({
    images: [],
    imagePosition: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
    isIcon: false
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/images-grid.scss.js




var MOBILE_GRID_IMAGE_SIZE_PX = "".concat(MOBILE_GRID_IMAGE_SIZE, "px");
var SM_PX = "".concat(vp_sizes.SM, "px");
var MAX_DESKTOP_GRID_WIDTH_PX = "".concat(vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px");
var ITEMS_MARGIN = 16;
var ITEMS_MARGIN_PX = "".concat(ITEMS_MARGIN, "px");
var StyledImagesGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euxwbea0"
})("display:flex;flex-wrap:wrap;justify-content:center;&.no-wrap{flex-wrap:nowrap;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){flex-wrap:wrap;}}.grid-image-container{display:flex;flex-direction:column;margin:", ITEMS_MARGIN_PX, ";padding:16px 0;width:var(--grid-width);&.dynamic-width{width:unset;flex:1 1 0;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){width:var(--grid-width);flex:unset;}}.full-paragraph-wrapper{flex:1;margin-top:16px;&.buttons-alignment{.button-wrapper{min-height:56px;align-items:end;margin-top:auto;}}.full-paragraph{height:100%;}}.grid-image-wrapper{&.with-shadow{", (0,constants.getComponentShadow)(), "}}}@media (min-width:", SM_PX, ") and (max-width:", MAX_DESKTOP_GRID_WIDTH_PX, "){.grid-image-container{width:calc(33vw - ", ITEMS_MARGIN * 2, "px) !important;.grid-image{width:100% !important;.image{width:100% !important;}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.grid-image-container{.grid-image-wrapper{.grid-image{.image{width:", MOBILE_GRID_IMAGE_SIZE_PX, ";height:auto;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/images-grid.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var ImagesGrid = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ImagesGrid, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ImagesGrid);
    function ImagesGrid() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ImagesGrid);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldAddEmptyContainer", function() {
            var _props = _this.props, images = _props.images, numberOfCardsInRow = _props.numberOfCardsInRow;
            return numberOfCardsInRow && numberOfCardsInRow >= images.length;
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ImagesGrid, [
        {
            key: "renderImages",
            value: function renderImages() {
                var _props = this.props, images = _props.images, isWithParagraph = _props.isWithParagraph, imagePosition = _props.imagePosition, textAlign = _props.textAlign, disableFixedWidth = _props.disableFixedWidth, titleSize = _props.titleSize, textSize = _props.textSize, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, imageStyle = _props.imageStyle, isIcon = _props.isIcon, numberOfCardsInRow = _props.numberOfCardsInRow, fitHeightToImgHeight = _props.fitHeightToImgHeight, buttonTopMargin = _props.buttonTopMargin, alignButtons = _props.alignButtons;
                return images.map(function(image, index) {
                    var ref = getImageSize(numberOfCardsInRow || images.length, isMobileOrTabletBrowser), height = ref.height, width = ref.width;
                    var fullParagraph = image.fullParagraph, shadow = image.shadow, restImageProps = _object_without_properties(image, [
                        "fullParagraph",
                        "shadow"
                    ]);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("grid-image-container", {
                            "dynamic-width": disableFixedWidth
                        }),
                        style: {
                            "--grid-width": "".concat(width, "px")
                        },
                        children: [
                            (restImageProps === null || restImageProps === void 0 ? void 0 : restImageProps.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("grid-image-wrapper", shadow && "with-shadow"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, _object_spread_props(_object_spread({
                                    height: fitHeightToImgHeight || isIcon ? "auto" : height,
                                    width: width,
                                    imageStyle: imageStyle,
                                    imagePosition: imagePosition
                                }, restImageProps), {
                                    className: "image"
                                }))
                            }),
                            isWithParagraph && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("full-paragraph-wrapper", {
                                    "buttons-alignment": alignButtons
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread_props(_object_spread({}, fullParagraph), {
                                    textAlign: textAlign,
                                    titleSize: titleSize,
                                    textSize: textSize,
                                    buttonTopMargin: buttonTopMargin
                                }))
                            })
                        ]
                    }, index);
                });
            }
        },
        {
            key: "renderEmpty",
            value: function renderEmpty() {
                var _props = this.props, images = _props.images, numberOfCardsInRow = _props.numberOfCardsInRow, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser;
                var emptyPlaces = (0,arrays.gettArrayWithIncrementingNumbers)(numberOfCardsInRow - images.length);
                var width = getImageSize(numberOfCardsInRow || images.length, isMobileOrTabletBrowser).width;
                return emptyPlaces.map(function(index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-image-container",
                        style: {
                            width: width
                        }
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, imagesGap = _props.imagesGap, disableFixedWidth = _props.disableFixedWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledImagesGrid, {
                    className: classnames_default()("images-grid", {
                        "no-wrap": disableFixedWidth
                    }),
                    style: {
                        gap: imagesGap
                    },
                    children: [
                        this.renderImages(),
                        this.shouldAddEmptyContainer() && this.renderEmpty()
                    ]
                });
            }
        }
    ]);
    return ImagesGrid;
}(react.PureComponent);
/* harmony default export */ var images_grid = ((0,generic_config_context/* withGenericConfig */.P)(ImagesGrid));
ImagesGrid.defaultProps = default_props;


/***/ }),

/***/ 3753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ImageWithParagraphGridComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid.js + 3 modules
var images_grid = __webpack_require__(95890);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-component.scss.js


var StyledImageWithParagraphGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e5pxcqz0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;padding:0;@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){padding:8px;}");

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var default_props = __webpack_require__(7484);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/default-props.js



/* harmony default export */ var image_with_paragraph_grid_default_props = ({
    images: [
        {
            src: "/static/img/segment-layout-default-images/grid/man-with-blue-shirt.png",
            fullParagraph: default_props/* default */.Z
        },
        {
            src: "/static/img/segment-layout-default-images/grid/woman-with-sunglasses-and-orange-shirt.png",
            fullParagraph: default_props/* default */.Z
        },
        {
            src: "/static/img/segment-layout-default-images/grid/man-with-hat-and-sunglasses.png",
            fullParagraph: default_props/* default */.Z
        },
        {
            src: "/static/img/segment-layout-default-images/grid/woman-with-sunglasses-in-the-wind.png",
            fullParagraph: default_props/* default */.Z
        }
    ],
    paddingTop: "56px",
    paddingBottom: "56px",
    imagePosition: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
    textAlign: "left",
    titleSize: sizes.MD,
    textSize: sizes.MD,
    autoHeight: false
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var ImageWithParagraphGridComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ImageWithParagraphGridComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ImageWithParagraphGridComponent);
    function ImageWithParagraphGridComponent() {
        (0,_class_call_check/* default */.Z)(this, ImageWithParagraphGridComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ImageWithParagraphGridComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, images = _this_props.images, imagePosition = _this_props.imagePosition, textAlign = _this_props.textAlign, titleSize = _this_props.titleSize, textSize = _this_props.textSize, autoHeight = _this_props.autoHeight, rest = _object_without_properties(_this_props, [
                    "images",
                    "imagePosition",
                    "textAlign",
                    "titleSize",
                    "textSize",
                    "autoHeight"
                ]);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWithParagraphGridComponent, {
                    className: "image-with-paragraph-grid-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_grid/* default */.Z, _object_spread({
                        images: images,
                        isWithParagraph: true,
                        imagePosition: imagePosition,
                        textAlign: textAlign,
                        titleSize: titleSize,
                        textSize: textSize,
                        fitHeightToImgHeight: autoHeight
                    }, rest))
                });
            }
        }
    ]);
    return ImageWithParagraphGridComponent;
}(react.PureComponent);

ImageWithParagraphGridComponent.defaultProps = image_with_paragraph_grid_default_props;


/***/ }),

/***/ 29179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ imagesProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);


var USE_CASES_KEYS = {
    FINANCE: "Finance",
    PROJECT_MANAGEMENT: "Project management",
    MARKETING_WORKFLOWS: "Marketing workflows",
    CREATIVE_AND_DESIGN: "Creative and design",
    IT: "IT",
    TASK_MANAGEMENT: "Task management",
    OPERATIONS: "Operations",
    SALES_ENABLEMENT: "Sales enablement",
    CONSTRUCTION: "Construction",
    HR: "HR"
};
var getParagraphProps = function(param) {
    var title = param.title, body = param.body;
    return {
        title: title,
        body: body,
        topic: {}
    };
};
var imagesProps = [
    {
        src: null,
        fullParagraph: getParagraphProps({
            title: "Plan and manage budgets",
            body: "See a full breakdown of all cross-department budgets, track costs, and budget allocation in one place."
        })
    },
    {
        src: null,
        fullParagraph: getParagraphProps({
            title: "Real-time dashboards",
            body: "Share data across your organization through fully customizable dashboards and widgets."
        })
    },
    {
        src: null,
        fullParagraph: getParagraphProps({
            title: "Keep track of requests and approvals",
            body: "Manage and track in real-time all incoming requests and approvals by using a custom request form."
        })
    }
];
var _obj;
var tabsProps = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.FINANCE, {
    alt: "Finance requests board, a finance overview dashboard and a Stripe notification"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.PROJECT_MANAGEMENT, {
    alt: "Project requests & approvals board, team iteration gantt and a project approval process form"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.MARKETING_WORKFLOWS, {
    alt: "Marketing calendar, social media post request form, click rate pie chart and monthly budget amount"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.CREATIVE_AND_DESIGN, {
    alt: "Creative projects kanban, creative brief form request form and a user update with teammate's reply"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.IT, {
    alt: "IT requests board with a request update and an IT ticket request form"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.TASK_MANAGEMENT, {
    alt: "Team planning board, task overview dashboard and a user update with teammate's reply"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.OPERATIONS, {
    alt: "Office request overview dashboard, request form and event RSVP board shown in the mobile app"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.SALES_ENABLEMENT, {
    alt: "Sales enablement materials dashboard, a user update with teammates' replies and a slack automation"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.CONSTRUCTION, {
    alt: "Construction project dashboard and a construction schedule board shown in the mobile app"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, USE_CASES_KEYS.HR, {
    alt: "Recruitment pipeline dashboard, an application form and zoom, slack and gmail integrations"
}), _obj);
/* harmony default export */ __webpack_exports__["Z"] = ({
    theme: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BACKGROUND_GRAY_COLOR_NAME,
    autoplay: true,
    autoplaySpeed: "10000",
    tabs: [
        {
            tabLabel: "Finance",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Finance.png",
                        alt: tabsProps[USE_CASES_KEYS.FINANCE].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/Use_case_mobile/Finance.png",
                        alt: tabsProps[USE_CASES_KEYS.FINANCE].alt
                    }
                },
                images: imagesProps
            }
        },
        {
            tabLabel: "Project management",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Project_managemnt.png",
                        alt: tabsProps[USE_CASES_KEYS.PROJECT_MANAGEMENT].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/Project_managemnt.png",
                        alt: tabsProps[USE_CASES_KEYS.PROJECT_MANAGEMENT].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Collaborate on projects in real-time",
                            body: "Collaborate with relevant stakeholders on projects. Stay on top of deadlines, priorities, and changes as they happen."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Get a full project overview",
                            body: "See where projects stand at a glance with Gantt and Kanban views to maximize your workflow."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Plan and track projects",
                            body: "Bring together deadlines, stakeholders, and budgets in one place. Plan, track, and manage every aspect of your project."
                        })
                    }
                ]
            }
        },
        {
            tabLabel: "Marketing workflows",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
                        alt: tabsProps[USE_CASES_KEYS.MARKETING_WORKFLOWS].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/Marketing.png",
                        alt: tabsProps[USE_CASES_KEYS.MARKETING_WORKFLOWS].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Manage marketing requests",
                            body: "Organize how you receive and handle marketing requests so you get them to the right people."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Streamline content creation",
                            body: "Organize and track progress at a glance to ensure every piece moves through the right stages."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Centralize marketing projects",
                            body: "Plan and track business goals, budgets, and marketing campaigns from A-Z."
                        })
                    }
                ]
            }
        },
        {
            tabLabel: "Creative and design",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Creative_and_design.png",
                        alt: tabsProps[USE_CASES_KEYS.CREATIVE_AND_DESIGN].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/Creative_and_design.png",
                        alt: tabsProps[USE_CASES_KEYS.CREATIVE_AND_DESIGN].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Shareable forms for quick approvals",
                            body: "Create and customize your own forms to streamline creative and design requests and approvals, in one place."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Organize digital assets in one place",
                            body: "Manage and collaborate on digital assets, and easily share files with stakeholders and your team in one place."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Design team planning",
                            body: "Keep your design team's board organized, whether it's reviewing briefs, organizing files, and more."
                        })
                    }
                ]
            }
        },
        {
            tabLabel: "IT",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/IT.png",
                        alt: tabsProps[USE_CASES_KEYS.IT].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/IT.png",
                        alt: tabsProps[USE_CASES_KEYS.IT].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Visualize service desk performance",
                            body: "See your IT operation at a glance with widget-rich dashboards illustrating SLAs, priorities, and issue types."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Auto-assign IT requests",
                            body: "Automate employee requests, assign them to the right person, and receive notifications when updates are made."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Service management in one place",
                            body: "View all requests in one place and view important information such as requester's details, issue type, and uploaded files."
                        })
                    }
                ]
            }
        },
        {
            tabLabel: "Task management",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Task_management.png",
                        alt: tabsProps[USE_CASES_KEYS.TASK_MANAGEMENT].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/Task_management.png",
                        alt: tabsProps[USE_CASES_KEYS.TASK_MANAGEMENT].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Collaborate on tasks",
                            body: "Work together effectively and on time with all task-related information, including files, ideas, and feedback."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Turn requests into tasks",
                            body: "Turn form submissions into tasks, and assign the right people to them to move work forward."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Visualize task progress",
                            body: "Custom dashboards display important info. such as status and priority to give you a clear picture of where tasks stand."
                        })
                    }
                ]
            }
        },
        {
            tabLabel: "Operations",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Operations.png",
                        alt: tabsProps[USE_CASES_KEYS.OPERATIONS].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/Operations.png",
                        alt: tabsProps[USE_CASES_KEYS.OPERATIONS].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Manage online and offline events",
                            body: "Manage and plan all your events in one place. Track tasks and statuses and make it easy for everyone to collaborate."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Streamline facility requests",
                            body: "Organize all facility requests in one place. Create a request form so employees can submit requests easily."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Identify patterns and trends",
                            body: "Gain insight into gaps within your organization and improve operations and workflows."
                        })
                    }
                ]
            }
        },
        {
            tabLabel: "Sales enablement",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Sales.png",
                        alt: tabsProps[USE_CASES_KEYS.SALES_ENABLEMENT].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/Sales.png",
                        alt: tabsProps[USE_CASES_KEYS.SALES_ENABLEMENT].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "One place for sales enablement",
                            body: "From case studies to pitch decks, organize and manage all sales materials. Let sales reps know when new content is ready."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Real-time visibility",
                            body: "Easily create dashboards that reflect team performance, deal status, sales activities, and more."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Manage sales workflows",
                            body: "Manage tasks and projects for the team, sales updates, and prospect inquiries in one place via custom forms."
                        })
                    }
                ],
                banner: {
                    productType: "crm",
                    title: "<b>A product built for customer-facing teams</b>",
                    body: "Explore monday CRM for exclusive capabilities and integrations",
                    buttonText: "Visit monday CRM"
                }
            }
        },
        {
            tabLabel: "Construction",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Construction.png",
                        alt: tabsProps[USE_CASES_KEYS.CONSTRUCTION].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/Construction.png",
                        alt: tabsProps[USE_CASES_KEYS.CONSTRUCTION].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Stay connected on the go",
                            body: "Organize projects and stay on schedule wherever you are with monday.com's iOS and Android apps."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Track projects at every stage",
                            body: "Streamline the office-field communication, and monitor the progress of projects in real time."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "See the full picture",
                            body: "Keep track of construction projects at a glance using automatically updating dashboards, and high-level overviews."
                        })
                    }
                ]
            }
        },
        {
            tabLabel: "HR",
            tabContent: {
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/HR.png",
                        alt: tabsProps[USE_CASES_KEYS.HR].alt
                    }
                },
                mobileAsset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case_mobile/HR.png",
                        alt: tabsProps[USE_CASES_KEYS.HR].alt
                    }
                },
                images: [
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Recruitment workflow overview",
                            body: "View the entire hiring process in a high-level dashboard, from candidate to hire."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "Centralize employee information",
                            body: "Manage and collaborate on HR documents from resumes to contracts and in one place."
                        })
                    },
                    {
                        src: null,
                        fullParagraph: getParagraphProps({
                            title: "High-level overview",
                            body: "Keep track of requests per department, request types, and more, to improve your workflow."
                        })
                    }
                ]
            }
        }
    ]
});


/***/ }),

/***/ 9306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_cases_tabs_desktop_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./static/svg/carousel-prev.svg
var carousel_prev = __webpack_require__(69395);
// EXTERNAL MODULE: ./static/svg/carousel-next.svg
var carousel_next = __webpack_require__(54798);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-component.js + 2 modules
var image_with_paragraph_grid_component = __webpack_require__(3753);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/regular-button.js + 1 modules
var regular_button = __webpack_require__(35662);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-case-product-banner/use-case-product-banner.scss.js



var StyledUseCaseProductBanner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tf0n1h0"
})("display:flex;justify-content:space-between;align-items:center;", (0,constants.getComponentShadow)(), "  gap:32px;padding:16px 24px;.use-case-product-banner-logo-and-text-wrapper{display:flex;gap:16px;.use-case-product-banner-logo{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;.core-badge-component{height:fit-content;margin-top:10px;}svg{margin-top:4px;border-radius:8px;border:1px solid #dcdfec;width:52px;height:52px;}}.use-case-product-banner-text{text-align:left;max-width:940px;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){display:flex;flex-direction:column;margin:0 32px 32px;padding:8px 16px 20px;gap:16px;.use-case-product-banner-logo-and-text-wrapper{display:flex;flex-direction:column;gap:0px;.use-case-product-banner-logo{svg{margin-top:0;border:none;}}.use-case-product-banner-text{text-align:center;.full-paragraph{font-size:0.8125rem;line-height:21px;font-weight:400;}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-case-product-banner/use-case-product-banner.js








var UseCaseProductBanner = function(props) {
    var _productBannerProps_productType, _productBannerProps_productType1, _productBannerProps_productType2;
    var theme = props.theme, productType = props.productType, title = props.title, body = props.body, buttonText = props.buttonText;
    var Icon = products/* productBannerProps */.M8 === null || products/* productBannerProps */.M8 === void 0 ? void 0 : (_productBannerProps_productType = products/* productBannerProps */.M8[productType]) === null || _productBannerProps_productType === void 0 ? void 0 : _productBannerProps_productType.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUseCaseProductBanner, {
        className: "use-case-product-banner",
        style: {
            background: colors/* default */.Z[theme] || colors/* default */.Z[color_consts.WHITE_COLOR_NAME]
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "use-case-product-banner-logo-and-text-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "use-case-product-banner-logo",
                        children: Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "use-case-product-banner-text",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, {
                            title: title,
                            body: body,
                            topic: {},
                            titleSize: sizes.XS,
                            textSize: sizes.MD,
                            mobileTextAlign: "center"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "use-case-product-banner-button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(regular_button/* default */.Z, {
                    buttonText: buttonText,
                    color: products/* productBannerProps */.M8 === null || products/* productBannerProps */.M8 === void 0 ? void 0 : (_productBannerProps_productType1 = products/* productBannerProps */.M8[productType]) === null || _productBannerProps_productType1 === void 0 ? void 0 : _productBannerProps_productType1.buttonColor,
                    textColor: "revert",
                    outline: true,
                    url: products/* productBannerProps */.M8 === null || products/* productBannerProps */.M8 === void 0 ? void 0 : (_productBannerProps_productType2 = products/* productBannerProps */.M8[productType]) === null || _productBannerProps_productType2 === void 0 ? void 0 : _productBannerProps_productType2.url,
                    isOpenLinkInNewTab: true
                })
            })
        ]
    });
};
/* harmony default export */ var use_case_product_banner = (UseCaseProductBanner);

// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var basic_header_constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./utils/dom.js
var dom = __webpack_require__(5512);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-desktop-component/use-cases-tabs-desktop-component.scss.js





var StyledUseCasesTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15z97620"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-direction:column;align-items:center;.use-cases-tabs-navigation{display:flex;gap:8px;justify-content:center;max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, ";flex-wrap:wrap;.use-cases-tab-nav-button-wrapper{font-size:0.875rem;font-weight:500;padding:8px 16px;border-radius:20px;border:1px solid ", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";white-space:nowrap;transition:background-color 0.2s ease-in-out,color 0.2s ease-in-out,border-color 0.2s ease-in-out;&:hover{background-color:", colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";cursor:pointer;}&.selected{background-color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ';}}}.carousel-wrapper{width:calc(1440px - 48px);max-width:calc(100vw - 48px);align-self:center;.slick-slide[aria-hidden="true"]{.use-case-product-banner-button{.button-component{display:none;}}}.carousel-item{text-align:center;.use-case-tab-content{padding:0 48px;.use-case-product-banner{.use-case-product-banner-text{.full-paragraph{.title-wrapper{margin-bottom:0;.core-title-container .core-title{font-size:1.125rem;}}}}.use-case-product-banner-button{.regular-button{width:max-content;}}}}}.carousel-arrow-wrapper{cursor:pointer;z-index:', z_index/* TOP_LAYER */.nA, ";text-align:center;width:64px;height:64px;outline:revert;top:22vw;&:before{display:none;}&:hover{svg{path{fill:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}}svg{height:100%;width:16px;path{fill:", colors/* default.mud */.Z.mud, ";transition:fill 0.2s ease-in-out;}}}}&.projects-orange{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";&:hover{color:", colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_PROJECTS_ORANGE_COLOR_NAME], ";}&.selected{background-color:", colors/* default */.Z[color_consts.DARK_PROJECTS_ORANGE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.carousel-wrapper{.carousel-arrow-wrapper{&:hover{svg{path{fill:", colors/* default */.Z[color_consts.PROJECTS_ORANGE_COLOR_NAME], ";}}}}}}&.white{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default.asphalt */.Z.asphalt, ";&:hover{border-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";background-color:transparent;}&.selected{background-color:rgba(255,255,255,0.2);border-color:rgba(255,255,255,0.2);color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}}&.dev-lighter-tint-01{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.DEV_LIGHT_TINT_02], ";&:hover{border-color:", colors/* default */.Z[color_consts.BRAND_PRIMARY_GREEN], ";color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";background-color:transparent;}&.selected{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";background-color:", colors/* default */.Z[color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME], ";border-color:", colors/* default */.Z[color_consts.DEV_LIGHTER_TINT_01_COLOR_NAME], ";}}}}&.crm-green{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";&:hover{color:", colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_CRM_GREEN_COLOR_NAME], ";}&.selected{background-color:", colors/* default */.Z[color_consts.DARK_CRM_GREEN_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.carousel-wrapper{.carousel-arrow-wrapper{&:hover{svg{path{fill:", colors/* default */.Z[color_consts.CRM_GREEN_COLOR_NAME], ";}}}}}}&.dev-green{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";&:hover{color:", colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_DEV_GREEN_COLOR_NAME], ";}&.selected{background-color:", colors/* default */.Z[color_consts.DARK_DEV_GREEN_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.carousel-wrapper{.carousel-arrow-wrapper{&:hover{svg{path{fill:", colors/* default */.Z[color_consts.DEV_GREEN_COLOR_NAME], ";}}}}}}&.marketing-red{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";&:hover{color:", colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_MARKETING_RED_COLOR_NAME], ";}&.selected{background-color:", colors/* default */.Z[color_consts.DARK_MARKETING_RED_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.carousel-wrapper{.carousel-arrow-wrapper{&:hover{svg{path{fill:", colors/* default */.Z[color_consts.MARKETING_RED_COLOR_NAME], ";}}}}}}&.workos-iris{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";&:hover{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_WORK_OS_IRIS_COLOR_NAME], ";}&.selected{background-color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.carousel-wrapper{.carousel-arrow-wrapper{&:hover{svg{path{fill:", colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}}}}}&.crm-dark-tint-01{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";&:hover{color:", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.CRM_LIGHTER_TINT_01], ";}&.selected{background-color:", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.carousel-wrapper{.carousel-arrow-wrapper{&:hover{svg{path{fill:", colors/* default */.Z[color_consts.CRM_DARK_TINT_01_COLOR_NAME], ";}}}}}}&.crm-darker-tint-02{.use-cases-tabs-navigation{.use-cases-tab-nav-button-wrapper{border:1px solid ", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";&:hover{color:", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.CRM_LIGHTER_TINT_01], ";}&.selected{background-color:", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}}.carousel-wrapper{.carousel-arrow-wrapper{&:hover{svg{path{fill:", colors/* default */.Z[color_consts.CRM_DARKER_TINT_02_COLOR_NAME], ";}}}}}}@media (min-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){.carousel-wrapper{.carousel-arrow-wrapper{top:305px;}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){.images-grid{.grid-image-container{width:calc(28vw - 32px) !important;}}}");

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/default-props.js
var default_props = __webpack_require__(29179);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-desktop-component/use-cases-tabs-desktop-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var CAROUSEL_LEFT_SWIPE = "left";
var CAROUSEL_RIGHT_SWIPE = "right";
var VISIBILITY_SENSOR_OFFSET = -100;
var DEFAULT_AUTO_PLAY_SPEED = 10000;
var UseCasesTabsDesktopComponent = function(props) {
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)(null), carouselRef = ref1[0], setCarouselRef = ref1[1];
    var ref2 = (0,react.useState)(false), wasComponentEverVisible = ref2[0], setWasComponentEverVisible = ref2[1];
    var ref3 = (0,react.useRef)(null);
    var autoplay = props.autoplay, autoplaySpeed = props.autoplaySpeed, tabs = props.tabs, theme = props.theme, buttonsColor = props.buttonsColor, scrollWhenButtonClicked = props.scrollWhenButtonClicked, replacementItemRenderer = props.replacementItemRenderer, hideArrows = props.hideArrows, disableDraggable = props.disableDraggable;
    var defaultItemRenderer = function(tab) {
        var ref = (tab === null || tab === void 0 ? void 0 : tab.tabContent) || {}, asset = ref.asset, images = ref.images, _banner = ref.banner, banner = _banner === void 0 ? {} : _banner;
        var tabImages = images || default_props/* imagesProps */.i;
        var imagesWithoutTopic = tabImages === null || tabImages === void 0 ? void 0 : tabImages.map(function(image) {
            return _object_spread_props(_object_spread({}, image), {
                fullParagraph: _object_spread_props(_object_spread({}, image.fullParagraph), {
                    topic: {}
                })
            });
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "use-case-tab-content",
            children: [
                asset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "use-case-tab-asset",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, asset))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "use-case-tab-paragraphs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_with_paragraph_grid_component["default"], {
                        images: imagesWithoutTopic,
                        titleSize: sizes/* XS_L */.L4,
                        textSize: sizes.XS,
                        textAlign: "center"
                    })
                }),
                (banner === null || banner === void 0 ? void 0 : banner.productType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(use_case_product_banner, _object_spread({
                    theme: theme
                }, banner))
            ]
        });
    };
    var navItemRenderer = function(tab, index) {
        var onNavItemClick = function() {
            setSelectedTab(index);
            if (scrollWhenButtonClicked) {
                (0,dom/* scrollIntoViewWithOffset */.H)(ref3, basic_header_constants/* default.BASIC_HEADER_HEIGHT */.Z.BASIC_HEADER_HEIGHT);
            }
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
                kind: tab === null || tab === void 0 ? void 0 : tab.tabLabel,
                info1: index
            });
            carouselRef.slickGoTo(index);
        };
        var selected = selectedTab === index;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: classnames_default()("use-cases-tab-nav-button-wrapper", {
                selected: selected
            }),
            onClick: onNavItemClick,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onNavItemClick),
            role: "tab",
            "aria-selected": selected,
            tabIndex: 0,
            children: tab.tabLabel
        }, index);
    };
    var PrevArrow = function(arrowProps) {
        var className = arrowProps.className, style = arrowProps.style, onClick = arrowProps.onClick;
        var onPrevArrowClick = function() {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                kind: tabs === null || tabs === void 0 ? void 0 : tabs[selectedTab].tabLabel,
                info1: selectedTab,
                info3: "prev"
            });
            onClick();
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: classnames_default()(className, "carousel-arrow-wrapper", "prev"),
            onClick: onPrevArrowClick,
            tabIndex: 0,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onPrevArrowClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_prev/* default */.Z, {})
        });
    };
    var NextArrow = function(arrowProps) {
        var className = arrowProps.className, style = arrowProps.style, onClick = arrowProps.onClick;
        var onNextArrowClick = function() {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                kind: tabs === null || tabs === void 0 ? void 0 : tabs[selectedTab].tabLabel,
                info1: selectedTab,
                info3: "next"
            });
            onClick();
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: classnames_default()(className, "carousel-arrow-wrapper", "next"),
            onClick: onNextArrowClick,
            tabIndex: 0,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_next/* default */.Z, {})
        });
    };
    var itemRenderer = replacementItemRenderer ? replacementItemRenderer : defaultItemRenderer;
    var carouselProps = {
        items: tabs,
        itemRenderer: itemRenderer,
        defaultIndex: 0,
        slidesToShow: 1,
        autoplay: autoplay,
        autoplaySpeed: parseInt(autoplaySpeed) || DEFAULT_AUTO_PLAY_SPEED,
        centerMode: false,
        infinite: true,
        onRefSet: setCarouselRef,
        arrows: true,
        nextArrow: !hideArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {}),
        prevArrow: !hideArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrow, {}),
        draggable: !disableDraggable
    };
    var onCarouselChange = function(current) {
        // fix selectedTab index in case of a glitch
        if (current !== selectedTab) {
            setSelectedTab(current);
        }
    };
    var onCarouselSwipe = function(direction) {
        var newSlide = selectedTab;
        if (direction === CAROUSEL_LEFT_SWIPE && selectedTab < tabs.length - 1) {
            newSlide = selectedTab + 1;
        }
        if (direction === CAROUSEL_RIGHT_SWIPE && selectedTab > 0) {
            newSlide = selectedTab - 1;
        }
        setSelectedTab(newSlide);
    };
    var onVisibilityChange = function(isVisible) {
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUseCasesTabsDesktopComponent, {
            className: classnames_default()("use-cases-tabs-component", buttonsColor),
            ref: ref3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "use-cases-tabs-navigation",
                    role: "tablist",
                    "aria-label": "Use cases tabs",
                    children: tabs.map(function(tab, index) {
                        return navItemRenderer(tab, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "carousel-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread_props(_object_spread({}, carouselProps), {
                        onChange: function(current) {
                            return onCarouselChange(current);
                        },
                        onSwipe: onCarouselSwipe
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var use_cases_tabs_desktop_component = (UseCasesTabsDesktopComponent);


/***/ }),

/***/ 84657:
/***/ (function(module) {


var convertToArrayIfNeeded = function(obj) {
    return Array.isArray(obj) ? obj : [
        obj
    ];
};
// Finds an empty cell index in the given array
var findEmptyIndex = function(arr) {
    if (arr) {
        for(var i = 0; i < arr.length; i++){
            if (!arr[i]) {
                return i;
            }
        }
        return arr.length;
    }
    return -1;
};
// returns a random value from the given array
var getRandomValue = function(arr) {
    var randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
};
// moves the given values to the beginning of the array
var moveToBeginningIfExists = function(arr, valuesToBeAtBeginning) {
    if (arr && valuesToBeAtBeginning) {
        for(var i = valuesToBeAtBeginning.length - 1; i >= 0; i--){
            var value = valuesToBeAtBeginning[i];
            var index = arr.indexOf(value);
            if (index > -1) {
                arrayMove(arr, index, 0);
            }
        }
    }
    return arr;
};
var arrayMove = function(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
};
var gettArrayWithIncrementingNumbers = function(size) {
    return Array.from(Array(size).keys());
};
module.exports = {
    convertToArrayIfNeeded: convertToArrayIfNeeded,
    findEmptyIndex: findEmptyIndex,
    getRandomValue: getRandomValue,
    moveToBeginningIfExists: moveToBeginningIfExists,
    arrayMove: arrayMove,
    gettArrayWithIncrementingNumbers: gettArrayWithIncrementingNumbers
};


/***/ })

}]);